import { ApiResponse, getRequest } from "@/data/apiClient";

export interface User {
  id: number;
  username: string;
  directory: string;
  forename: string;
  surname: string;
  micadUser: boolean;
  organisation: string;
  position: string;
  startDateTime: string;
  lastLoginDateTime: string;
  active: boolean;
  expirationTimestamp?: string;
  suspendedDate?: string;
  appRoles?: { [key: string]: string };
}

export const getUsers = async (
  includeParents: boolean
): Promise<ApiResponse<User[]>> => getRequest("users", { includeParents });
